import {
  fetchMonitoring,
  fetchMonitoringEvent,
  fetchReport
} from '../../../services/api/monitoring'
import { naturalCompare } from '../../../helpers'

function getRequestValue(request, key) {
  switch (key) {
    case 'monitoringStartDate':
      return request.monitoringStart
    case 'lastEventDate':
      return request.lastEvent != null ? request.lastEvent.reported : ""
    case 'lastEventName':
      return request.lastEvent != null ? request.lastEvent.name : ""
    case 'subjectFullName':
      return request.lastName
    case 'monitoringEndDate':
      return request.monitoringEndData
    default:
      return request[key]
  }
}

export const monitoring = {
  namespaced: true,
  state: {
    search: '',
    display: 10,
    page: 1,
    sort: {
      column: 'monitoringStartDate',
      order: 'desc'
    },
    currentSubjectId: null,
    monitoring: [],
    count: 0,
    pending: false
  },
  mutations: {
    save(state, data) {
      state.monitoring = data
      state.count = data.count;
    },
    setCurrentSubjectId(state, id) {
      state.monitoring.find(function (item) { return item.id == id; }).eventsToCheckOut = 0;
      state.currentSubjectId = id
    },
    resetCurrentSubject(state) {
      state.currentSubjectId = null
    },
    setPage(state, page) {
      state.page = page
    },
    setSort(state, sort) {
      state.sort = sort
    },
    search(state, search) {
      state.search = search || ''
      state.count = 0;
    },
    resetState(state) {
      state.page = 1
      state.search = ''
      state.monitoring = []
      state.currentSubjectId = null
    },
    setPending(state, bool) {
      state.pending = bool
    },
  },
  actions: {
    fetchMonitoring({ commit, dispatch }) {
      commit('setPending', true);
      return fetchMonitoring()
        .then(res => {
          commit('save', res.data);
          commit('setPending', false);
          return res
        })
        .catch(res => {
          dispatch('error', res, { root: true })
          commit('setPending', false);
          throw res
        })
    },
    fetchReport({ commit, dispatch }, link) {
      return fetchReport(link).catch(res => {
        dispatch('error', res, { root: true })
        throw res
      })
    },
    setCurrentSubjectId({ commit }, id) {
      commit('setCurrentSubjectId', id)
    },
    resetCurrentSubject({ commit }) {
      commit('resetCurrentSubject')
    },
    setPage({ commit }, page) {
      commit('setPage', page)
    },
    setSort({ commit }, sort) {
      commit('setSort', sort)
    },
    search({ commit }, search) {
      commit('search', search);
      commit('setPage', 1);
    },
    resetState({ commit }) {
      commit('resetState')
    }
  },
  getters: {
    filteredRecords({ monitoring: records, search }) {
      if (!search) {
        return records
      }
      return records.filter(record => {

        if (record.companyName) {
          return record.companyName.toLowerCase().includes(search.toLowerCase()) || record.companyName.toLowerCase() === search.toLowerCase();
        }

        let fullName = `${record.lastName.toLowerCase()} ${record.firstName.toLowerCase()}`;

        if (record.middleName) {
          fullName = `${fullName} ${record.middleName.toLowerCase()}`;
        }

        return record.lastName.toLowerCase().includes(search.toLowerCase())
          || record.firstName.toLowerCase().includes(search.toLowerCase())
          || (record.middleName && record.middleName.toLowerCase().includes(search.toLowerCase()))
          || search.toLowerCase() === fullName
      });
    },
    totalRecords(state, { filteredRecords }) {
      return filteredRecords.length
    },
    sortedRecords({ sort }, { filteredRecords }) {
      const sorted = filteredRecords.sort((a, b) => {
        return naturalCompare(
          getRequestValue(a, sort.column),
          getRequestValue(b, sort.column)
        )
      })
      return sort.order === 'asc' ? sorted : sorted.reverse()
    },
    paginatedRecords({ page, display }, { sortedRecords }) {
      return sortedRecords.slice((page - 1) * display, page * display)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/home/monitoring/store.js